<nav class="navbar navbar-default blue-bg">
    <div class="container container-fluid">
        <div class="navbar-header">
            <h1 class="navbar-brand">Podpisywanie wniosku
                <i class="pi pi-info-circle"
                   pTooltip="{{companyTypeId=='OF_P_1'
                   ? 'Podpis składa wnioskodawca bedący osoba fizyczną albo pełnomocnik w przypadku jego ustanowienia.'
                   : 'Podpis składa wnioskodawca będący osoba fizyczną albo osoby uprawnione do reprezentowania wnioskodawcy (zgodnie ze sposobem reprezentacji określonym w rejestrze KRS) lub pełnomocnik w przypadku ustanowienia.'}}"
                   aria-hidden="true">
                </i>
            </h1>
        </div>
    </div>
</nav>

<div class="flex-1">
    <p-messages [value]="message" [enableService]="false" [closable]="false" showTransitionOptions="0s" hideTransitionOptions="0s" styleClass="margin-top-bottom-10 w-11 mlrauto"/>
    <div class="text-align-center line-height-1-5">
        <h1>Czy jesteś uprawniony/a do jednoosobowego podpisania wniosku?<br/>
        <p-radioButton [(ngModel)]="signAllowed" [value]="true" label="TAK"></p-radioButton>&nbsp;
        <p-radioButton [(ngModel)]="signAllowed" [value]="false" label="NIE"></p-radioButton></h1>
    </div>

    <br/>

    <div class="grid justify-content-space-around">
        <p-card *ngIf="signAllowed" class="w-11 md:wp-5 flex flex-direction-column row-gap">
            Pozwala na podpisanie wniosku w aplikacji z wykorzystaniem m.in. Profilu Zaufanego.
            <br/>
            Po podpisaniu wniosku użytkownik otrzyma potwierdzenie w postaci pliku .zip.
            <br/>
            <ng-template pTemplate="footer">
                <p-button label="Podpisz wniosek" icon="pi pi-pencil" class="justify-content-center" (click)="signProposal()"></p-button>&nbsp;
            </ng-template>
        </p-card>

        <p-card *ngIf="signAllowed != undefined && !signAllowed" class="w-11 md:wp-5 flex flex-direction-column row-gap">
            Pozwala na pobranie wniosku do podpisu w celu podpisania przez uprawnioną osobę lub reprezentację podmiotu.<br/>
            Dokument pdf zawierający wszystkie podpisy powinien zostać załączony do właściwego wniosku znajdującego się na liście wniosków do podpisu za pomocą przycisku "Załącz".
            <ng-template pTemplate="footer">
                <p-button label="Pobierz wniosek" icon="pi pi-download" class="justify-content-center" (click)="downloadProposal()"></p-button>&nbsp;
            </ng-template>
        </p-card>
    </div>
</div>
<br/>
<div class="flex">
    <p-button label="Lista wniosków do podpisu" icon="pi pi-backward" iconPos="left" styleClass="ml" (click)="goToProposalsList()"></p-button>
</div>